import { useTranslation } from "react-i18next";

export function DeviationDeliveryHealth({ health }) {
  const { t } = useTranslation();
  const needsAttention = health?.status === "needs_attention";
  return (
    <section className={`rounded-2xl border p-4 ${needsAttention ? "border-amber-200 bg-amber-50" : "border-slate-200 bg-slate-50"}`}>
      <h3 className="text-sm font-semibold text-slate-900">{t("deviation.health.title")}</h3>
      <p className="mt-2 text-sm text-slate-700">{t("deviation.health.trigger")}</p>
      <p className="mt-2 text-sm text-slate-600">{t("deviation.health.unverified")}</p>
      {health?.issues?.length > 0 && <ul className="mt-3 list-disc space-y-2 pl-5 text-sm text-slate-800">
        {health.issues.map(({ code }) => <li key={code}>{t(`deviation.health.${code}`)}</li>)}
      </ul>}
      {health && <p className="mt-3 text-xs text-slate-600">{t("deviation.health.counts", {
        pending: health.pending_count || 0, overdue: health.overdue_count || 0, failed: health.failed_count || 0,
      })}</p>}
    </section>
  );
}
